<template>
  <div :class="$style.field">
    <label :for="id">
      {{ entity.label }}
      <i v-if="required">*</i>
    </label>
    <textarea
      :id="id"
      :readonly="readonly"
      v-model="value"
      rows="3"
      v-autosize
      :placeholder="entity.description"
      :name="name"
      :required="required"
      :maxlength="maxlength"
      :autocomplete="name"
    ></textarea>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import Field from "./field";

export default {
  mixins: [Field],
};
</script>

<style module lang="less" src="./field.less"></style>



// WEBPACK FOOTER //
// textarea-field.vue?ca222182